/**
 * ConsolidadoLeituraReport - Item-level report with manual vs scanner reading flag
 */
import React from 'react';
import { RelatorioGeraisTable, type Column } from './RelatorioGeraisTable';

const columns: Column[] = [
  { key: 'codigo', label: 'Código', align: 'center', width: '80px' },
  { key: 'hospital_nome', label: 'Hospital', width: '180px' },
  { key: 'data_hora', label: 'Data da Contagem', width: '140px' },
  { key: 'cliente_nome', label: 'Cliente', width: '160px' },
  { key: 'codigo_produto', label: 'Produto', width: '120px' },
  { key: 'descricao', label: 'Descrição', width: '220px' },
  { key: 'lote', label: 'Lote', width: '120px' },
  { key: 'data_validade', label: 'Validade', width: '100px' },
  { key: 'quantidade_sistema', label: 'Qtd Sistema', align: 'right', format: 'decimal', width: '100px' },
  { key: 'quantidade_contada', label: 'Qtd Contado', align: 'right', format: 'decimal', width: '100px' },
  { key: 'leitura_manual_display', label: 'Leitura Manual', align: 'center', width: '120px' },
];

interface Props {
  data: any[];
  loading?: boolean;
  totalRecords?: number;
  currentPage?: number;
  totalPages?: number;
  onPageChange?: (page: number) => void;
}

export const ConsolidadoLeituraReport: React.FC<Props> = ({
  data,
  loading,
  totalRecords,
  currentPage,
  totalPages,
  onPageChange,
}) => {
  // Transform data to add display field for leitura_manual
  const transformedData = data.map(item => ({
    ...item,
    leitura_manual_display: item.leitura_manual ? 'Sim' : 'Não',
  }));

  return (
    <RelatorioGeraisTable
      columns={columns}
      data={transformedData}
      loading={loading}
      showTotals={false}
      emptyMessage="Nenhum item encontrado no período selecionado."
      totalRecords={totalRecords}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
    />
  );
};
